(() => {
    let upsellProductsRemovedSession = sessionStorage.getItem("upsellProductsRemoved");
    let upsellProductsRemoved;
    let isUpdating = false; // Prevent multiple simultaneous updates
    let updateTimeout = null; // For debouncing

    if (upsellProductsRemovedSession) {
        upsellProductsRemoved = JSON.parse(upsellProductsRemovedSession); // FIX: Use JSON.parse
    } else {
        upsellProductsRemoved = [];
        let initialProductsRemovedSession = JSON.stringify(upsellProductsRemoved);
        sessionStorage.setItem("upsellProductsRemoved", initialProductsRemovedSession);
    }

    // Debounced version of checkCartItemsForUpsell
    const debouncedCheckCartItemsForUpsell = (delay = 150) => {
        if (updateTimeout) {
            clearTimeout(updateTimeout);
        }
        
        updateTimeout = setTimeout(() => {
            if (!isUpdating) {
                checkCartItemsForUpsell();
            }
        }, delay);
    };

    document.addEventListener("DOMContentLoaded", () => {
        if (window.dynamicUpsellArrayOfObjects && window.dynamicUpsellArrayOfObjects.length > 0) {
            debouncedCheckCartItemsForUpsell(0); // No delay on initial load
        }
    });

    // Add cart change listener with debouncing
    document.addEventListener("cart:changed", () => {
        console.log("Cart changed - updating upsells");
        debouncedCheckCartItemsForUpsell();
    });

    // Listen for custom rerender events
    document.addEventListener("rerenderCart", () => {
        console.log("Rerender cart - updating upsells");
        debouncedCheckCartItemsForUpsell();
    });

    const checkCartItemsForUpsell = () => {
        // Prevent multiple simultaneous updates
        if (isUpdating) {
            console.log("Update already in progress, skipping...");
            return;
        }

        isUpdating = true;
        console.log("Starting upsell update...");

        // fetch cart
        fetch("/cart.js")
            .then((res) => res.json())
            .then((cart) => {
                // Get fresh upsell data based on current cart
                getDynamicUpsellData(cart).then((dynamicUpsellData) => {
                    const upsellPool = [];

                    // loop through dynamicUpsellData
                    dynamicUpsellData.forEach((upsellItem) => {
                        const showPermanently = upsellItem.showPermanently;
                        
                        // Check if any cart item has this product in its upsell list
                        const shouldShowBasedOnCart = cart.items.some(cartItem => {
                            const upsellProducts = cartItem.properties?._upsell_products;
                            if (upsellProducts) {
                                const cleanedString = upsellProducts.replace(/[\[\]"]/g, '');
                                const upsellHandles = cleanedString.split(',').map(handle => handle.trim());
                                return upsellHandles.includes(upsellItem.handle);
                            }
                            return false;
                        });

                        // FIX: Only add if cart condition is met OR item should be shown permanently
                        if (shouldShowBasedOnCart || showPermanently) {
                            // Also check if the upsell product is not already in cart
                            const isAlreadyInCart = cart.items.some(cartItem => 
                                cartItem.product_id === upsellItem.id
                            );

                            if (!isAlreadyInCart) {
                                upsellPool.push({
                                    id: upsellItem.id,
                                    variantId: upsellItem.variantId,
                                    sku: upsellItem.sku,
                                    handle: upsellItem.handle,
                                    title: upsellItem.title,
                                    headline: {
                                        DE: upsellItem.headline.DE,
                                        EN: upsellItem.headline.EN,
                                        NL: upsellItem.headline.NL
                                    },
                                    price: upsellItem.price,
                                    compareAtPrice: upsellItem.compareAtPrice,
                                    image: upsellItem.image,
                                    markAsBestseller: upsellItem.markAsBestseller
                                });
                            }
                        }
                    });

                    // if cart items greater 0, shift last item to first position, to show last added item
                    if (cart.items.length > 0 && upsellPool.length > 0) {
                        const lastItem = upsellPool.pop();
                        upsellPool.unshift(lastItem);
                    }

                    // call helper functions for upsell
                    if (upsellPool.length > 0) {
                        buildUpsell(upsellPool);
                        handleUpsell(cart.items);
                        upsellSwiper();
                    } else {
                        const upsellSection = document.querySelector('.dynamic-upsell');
                        if (upsellSection) {
                            upsellSection.style.display = 'none';
                        }
                    }

                    const cartDrawer = document.querySelector('#cart-drawer');
                    if (cartDrawer && cartDrawer.querySelector('.dynamic-upsell__items') && 
                        cartDrawer.querySelector('.dynamic-upsell__items').scrollHeight == 0) {
                        cartDrawer.querySelector('.dynamic-upsell').style.display = 'none';
                    }

                    console.log("Upsell update completed");
                    isUpdating = false; // Reset the flag
                }).catch((error) => {
                    console.error("Error in getDynamicUpsellData:", error);
                    isUpdating = false; // Reset the flag even on error
                });
            })
            .catch((error) => {
                console.error("Error fetching cart:", error);
                isUpdating = false; // Reset the flag even on error
            });
    };

    // NEW: Function to get fresh upsell data based on current cart
    const getDynamicUpsellData = async (cart) => {
        // Extract all unique upsell handles from current cart items
        const allUpsellHandles = new Set();
        
        cart.items.forEach(cartItem => {
            const upsellProducts = cartItem.properties?._upsell_products;
            if (upsellProducts) {
                const cleanedString = upsellProducts.replace(/[\[\]"]/g, '');
                const upsellHandles = cleanedString.split(',').map(handle => handle.trim());
                upsellHandles.forEach(handle => allUpsellHandles.add(handle));
            }
        });

        // If no upsells found in cart, return empty array
        if (allUpsellHandles.size === 0) {
            return [];
        }

        // Fetch product data for these handles
        const handlesArray = Array.from(allUpsellHandles);
        const upsellData = [];

        // You might need to adapt this part based on how you want to fetch product data
        // Option 1: If you have access to Shopify's AJAX API
        for (const handle of handlesArray) {
            try {
                const response = await fetch(`/products/${handle}.js`);
                if (response.ok) {
                    const product = await response.json();
                    upsellData.push({
                        id: product.id,
                        variantId: product.variants[0].id,
                        sku: product.variants[0].sku,
                        handle: product.handle,
                        title: product.title,
                        headline: {
                            DE: "", // You'll need to adapt this based on how you store metafields
                            EN: "",
                            NL: ""
                        },
                        price: product.variants[0].price,
                        compareAtPrice: product.variants[0].compare_at_price,
                        image: product.images[0] || "",
                        markAsBestseller: false, // Adapt based on your metafields
                        showPermanently: false
                    });
                }
            } catch (error) {
                console.error(`Error fetching product ${handle}:`, error);
            }
        }

        return upsellData;
    };

    /******************************************************************/
    /* build upsell
    /******************************************************************/

    const buildUpsell = (upsellPool) => {
        const upsellEl = document.querySelector(".dynamic-upsell");
        if (!upsellEl) return;

        const dynamicUpsellItems = document.querySelector(".dynamic-upsell__items");
        const maxNumberOfUpsellItems = parseInt(upsellEl.dataset.maxNumberOfUpsellItems || 3);
        const countryCode = document.querySelector(".dynamic-upsell").dataset.countryCode.toUpperCase();
        let index = 0;

        // clear inner html
        dynamicUpsellItems.innerHTML = "";

        // build upsell items
        for (const upsellPoolItem of upsellPool) {
            // Check if the product has been removed by the user in the current session
            if (upsellProductsRemoved.includes(upsellPoolItem.variantId)) {
                continue; // Skip building this item
            }
            
            // break loop if index greater than maxNumberOfUpsellItems
            if (index >= maxNumberOfUpsellItems) break;

            dynamicUpsellItems.insertAdjacentHTML(
                "beforeend",
                `
                <div class="horizontal-product rounded-xs snap-start swiper-slide bg-custom swiper-slide-active" style="--background: 242 242 242; margin-right: 25px;" role="group" aria-label="${index + 1} / ${Math.min(upsellPool.length, maxNumberOfUpsellItems)}">
                    <a href="/products/${upsellPoolItem.handle}">
            
                        ${upsellPoolItem.markAsBestseller ? "<span class=\"dynamic-upsell__bestseller-badge\">🔥 Bestseller</span>" : ""}
                        
                        <img src="${upsellPoolItem.image}" alt="${upsellPoolItem.title}" loading="lazy" class="horizontal-product__image rounded-xs">
                    </a>
                
                    <div class="horizontal-product__info">
                        <div class="v-stack gap-0.5">
                            <a href="/products/${upsellPoolItem.handle}" data-instant="" class="text-sm bold">
                                <span class="cart-drawer__recommendations__productTitle reversed-link hover:show">
                                    ${(upsellPoolItem.headline[countryCode] !== "" && ["DE", "NL", "EN"].includes(countryCode))
                                    ? `${upsellPoolItem.headline[countryCode]}` : `${upsellPoolItem.title}`}
                                </span>
                            </a>
                            
                            ${upsellPoolItem.compareAtPrice ?
                                `
                                    <price-list class="price-list">
                                        <sale-price class="text-on-sale text-sm">
                                            <span class="sr-only">Angebot</span>${formatCentsToEuro(upsellPoolItem.price)}
                                        </sale-price>
                        
                                        <compare-at-price class="text-subdued text-sm line-through">
                                            <span class="sr-only">Regulärer Preis</span>${formatCentsToEuro(upsellPoolItem.compareAtPrice)}
                                        </compare-at-price>
                                    </price-list>
                                `
                                :
                                `
                                    <price-list class="price-list">
                                        <sale-price class="text-subdued text-sm">
                                            ${formatCentsToEuro(upsellPoolItem.price)}
                                        </sale-price>
                                    </price-list>
                                `
                            }
                        </div>
                        <div class="horizontal-product__cta">
                            <form method="post" action="/cart/add" id="complementary-product-sections--24045610172680__cart-drawer--${upsellPoolItem.id}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="quantity" value="1">
                                <input type="hidden" name="id" value="${upsellPoolItem.variantId}">
                
                                <quantity-selector class="quantity-selector">
                                    <button type="button" class="quantity-selector__button quantity-selector__button--minus" aria-label="Anzahl verringern" onclick="updateCartInputQty(this)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M18 12H6" stroke="#797979" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </button>
                                    <input inert="" id="complementary-product-sections--24045610172680__cart-drawer--${upsellPoolItem.id}-quantity" type="number" is="quantity-input" disabled="" inputmode="numeric" class="quantity-selector__input" name="quantity" form="complementary-product-sections--24045610172680__cart-drawer--${upsellPoolItem.id}" value="1" step="" min="" autocomplete="off">
                                    <button type="button" class="quantity-selector__button quantity-selector__button--plus" aria-label="Anzahl erhöhen" onclick="updateCartInputQty(this)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 6V12M12 12V18M12 12H18M12 12L6 12" stroke="#797979" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </button>
                                </quantity-selector>
                                <button type="submit" class="button button--sm button--subdued" is="custom-button">
                                    <div> Hinzufügen</div>
                                    <span class="button__loader">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                          </span></button>
                                <input type="hidden" name="product-id" value="${upsellPoolItem.id}"><input type="hidden" name="section-id" value="sections--24045610172680__cart-drawer"></form>
                        </div>
                    </div>
                    <button class="horizontal-product__remove">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M4 12L12 4M4 4L12 12" stroke="#797979" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            `
            );

            index++;
        }
    };

    /******************************************************************/
    /* handle upsell
    /******************************************************************/

    const handleUpsell = () => {
        const upsellSection = document.querySelector('section.dynamic-upsell');
        const upsellItems = document.querySelectorAll(".dynamic-upsell__items .swiper-slide");
        let upsellItemsRemoved = 0;

        console.log(upsellItems);

        upsellProductsRemoved = JSON.parse(sessionStorage.getItem("upsellProductsRemoved") || "[]");

        upsellItems.forEach((upsellItem) => {
            const upsellRemove = upsellItem.querySelector(".horizontal-product__remove");
            const variantId = parseInt(upsellItem.querySelector(".shopify-product-form input[name=\"id\"]")?.value);

            // Remove existing event listeners to prevent duplicates
            upsellRemove.replaceWith(upsellRemove.cloneNode(true));
            const newUpsellRemove = upsellItem.querySelector(".horizontal-product__remove");

            // handle remove click event
            newUpsellRemove.addEventListener("click", () => {
                upsellProductsRemoved.push(variantId);

                let uniqueUpsellProductsRemoved = [...new Set(upsellProductsRemoved)];
                let updatedUpsellProductsRemoved = JSON.stringify(uniqueUpsellProductsRemoved);
                sessionStorage.setItem("upsellProductsRemoved", updatedUpsellProductsRemoved);

                upsellItem.style.display = "none";
                
                const cartDrawer = document.querySelector('#cart-drawer');
                if (cartDrawer && cartDrawer.querySelector('.dynamic-upsell__items').scrollHeight === 0) {
                    cartDrawer.querySelector('.dynamic-upsell').style.display = 'none';
                }

                setTimeout(() => {
                    document.dispatchEvent(new CustomEvent("rerenderCart"));
                    console.log('cart rerender');
                }, 300); // Increased delay to prevent rapid firing
            });
        });

        upsellItems.forEach(item => {
            if (item.style.display === "none") {
                upsellItemsRemoved++;
            }
        });

        if (upsellSection) {
            if (upsellItems.length === upsellItemsRemoved) {
                upsellSection.style.display = 'none';
            } else if (upsellItems.length > 0) {
                upsellSection.style.display = 'block';
            }
        }
    };

    /******************************************************************/
    /* upsell swiper
    /******************************************************************/

    const upsellSwiper = () => {
        const dynamicUpsellSwiper = document.querySelector(".cart-drawer .dynamic-upsell__swiper");
        const upsellEl = document.querySelector('.cart-drawer .dynamic-upsell');

        if (dynamicUpsellSwiper?.swiper) {
            dynamicUpsellSwiper.swiper.destroy();
        }

        const visibleSlides = document.querySelectorAll(".dynamic-upsell__swiper .swiper-slide:not([style*=\"display: none\"])");

        if (visibleSlides.length == 1) {
            upsellEl.classList.add('dynamic-upsell--single');
        } else {
            upsellEl.classList.remove('dynamic-upsell--single');
        }

        new Swiper(".cart-drawer .dynamic-upsell__swiper", {
            loop: false,
            watchSlidesProgress: true,
            simulateTouch: true,
            allowTouchMove: visibleSlides.length > 1 ? true : false,
            slidesPerView: 1,
            spaceBetween: 10,
            grabCursor: true,
            mousewheel: {
                invert: false
            },
            navigation: {
                prevEl: document.querySelector(".dynamic-upsell__swiper .swiper-button-prev"),
                nextEl: document.querySelector(".dynamic-upsell__swiper .swiper-button-next")
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            breakpoints: {
                768: {
                    slidesPerView: visibleSlides.length > 1 ? 1.15 : 1
                }
            }
        });
    };

    /******************************************************************/
    /* MUTATION OBSERVER: REINIT UPSELL AFTER CART REBUILD
    /******************************************************************/

    const cartDrawer = document.querySelector("#cart-drawer");
    let observerExecuted = false; // Prevent multiple observer executions

    const dynamicUpsellObserver = new MutationObserver((mutations, observer) => {
        // Prevent multiple rapid executions
        if (observerExecuted) {
            return;
        }
        
        mutations.forEach((mutation) => {
            const emptyMessage = cartDrawer.querySelector('.empty-state');
            const upsellItemsWrapper = cartDrawer.querySelector(".dynamic-upsell__items");

            if (emptyMessage === null && upsellItemsWrapper && upsellItemsWrapper.childElementCount === 0) {
                observerExecuted = true;
                console.log("Mutation observer triggered - updating upsells");
                
                // Add a delay and use debounced function
                setTimeout(() => {
                    debouncedCheckCartItemsForUpsell(200);
                    // Reset the flag after some time
                    setTimeout(() => {
                        observerExecuted = false;
                    }, 1000);
                }, 150);
            }
        });
    });

    if (cartDrawer) {
        dynamicUpsellObserver.observe(cartDrawer, {
            childList: true,
            subtree: true
        });
    }

})();